import React, { useEffect } from 'react';

interface ICameraVideoProps {
    stream: any;
    videoRef: React.RefObject<HTMLVideoElement>;
}

function getIntialVideoStreamForPictureInPictureBeforeCameraIsAvailable() {
    // This was more or less copied from an example of how to intialise a video
    // with a stream before the source has been established (ie. before the user accepts permissions for using the webcam)
    // since we can only trigger picture in picture from a user event, they click the button and we launch a video instantly
    // with an empty black source, and then swap the source when the stream is available.

    let blackVideoStream = ({ width = 640, height = 480 } = {}) => {
        let canvas = Object.assign(document.createElement('canvas'), {
            width: 640,
            height: 480
        });
        //@ts-ignore
        canvas.getContext('2d').fillRect(0, 0, width, height);
        //@ts-ignore
        let stream = canvas.captureStream();
        return Object.assign(stream.getVideoTracks()[0], { enabled: false });
    };

    return new MediaStream([blackVideoStream()]);
}

function CameraVideo(props: ICameraVideoProps) {
    const { stream, videoRef } = props;

    useEffect(() => {
        videoRef.current!.srcObject =
            stream ||
            getIntialVideoStreamForPictureInPictureBeforeCameraIsAvailable();
        videoRef.current!.volume = 0;
    }, [stream]);

    return (
        <video
            ref={videoRef}
            autoPlay
            className="previewVideo"
            style={{
                visibility: 'hidden',
                height: '0px',
                width: '0px'
            }}
        />
    );
}

export default CameraVideo;
